const ServusNav = () => (
  <header className="global-header">
    <div className="burger-menu"></div>
    <div className="global-header__container">
      <div className="global-header__logo">
        <div className="site-logo">
          <a href="https://www.servustv.com" className="site-logo__home-link">
            <img
              src="https://account.redbull.com/bundles/assets/static/img/servus-black-no-tv.svg"
              alt="Servus"
              className="site-logo__logo"
            />
            <span className="site-logo__vertical-name">TV</span>
          </a>
        </div>
      </div>
      <div className="global-header__main-nav">
        <nav className="main-nav">
          <ul id="menu-main-navigation" className="main-nav__menu">
            <li
              id="menu-item-56"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-56 main-nav__menu-item"
            >
              <a
                href="https://www.servustv.com/jetzt-live/"
                className="main-nav__item-link"
                data-gtm-tracking="navigation"
                data-gtm-tracking-category="Navigation"
                data-gtm-tracking-action="Main Navigation"
                data-gtm-tracking-label="Jetzt Live"
              >
                Jetzt Live
              </a>
            </li>
            <li
              id="menu-item-14"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-14 main-nav__menu-item"
            >
              <a
                href="https://www.servustv.com/mediathek/"
                className="main-nav__item-link"
                data-gtm-tracking="navigation"
                data-gtm-tracking-category="Navigation"
                data-gtm-tracking-action="Main Navigation"
                data-gtm-tracking-label="Mediathek"
              >
                Mediathek
              </a>
            </li>
            <li
              id="menu-item-50"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-50 main-nav__menu-item"
            >
              <a
                href="https://www.servustv.com/tv-programm/"
                className="main-nav__item-link"
                data-gtm-tracking="navigation"
                data-gtm-tracking-category="Navigation"
                data-gtm-tracking-action="Main Navigation"
                data-gtm-tracking-label="TV-Programm"
              >
                TV-Programm
              </a>
            </li>
            <li
              id="menu-item-113100"
              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-113100 main-nav__menu-item"
            >
              <a
                href="https://www.servustv.com/podcast/"
                className="main-nav__item-link"
                data-gtm-tracking="navigation"
                data-gtm-tracking-category="Navigation"
                data-gtm-tracking-action="Main Navigation"
                data-gtm-tracking-label="Podcasts"
              >
                Podcasts
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="global-header__search" />
    </div>
  </header>
);

export default ServusNav;
